import { useState, useEffect, useCallback } from 'react';
import { useLogin } from '@/features/login';
import { StyledButton, CustomPin } from '@/shared/components';
import { reactive } from '@/core/reactive/reactive';

export const TwoFactorLogin = reactive.component(
  ({ services, monitors, form, dispatch }) => {
    const [twoFactor, setTwoFactor] = useState(() => ({
      pin: '',
      validationToken: form.twofactorValidationToken,
      userId: form.twofactorUserId,
    }));

    const { twoFactorLogin } = useLogin(services, dispatch);

    const handleLogin = useCallback(() => {
      twoFactorLogin(1, twoFactor.userId, twoFactor.validationToken, twoFactor.pin);
    }, [twoFactorLogin, twoFactor.userId, twoFactor.validationToken, twoFactor.pin]);

    useEffect(() => {
      if (twoFactor.pin) {
        handleLogin();
      }
    }, [twoFactor.pin, handleLogin]);

    return (
      <div className="w-full flex flex-col gap-4">
        <p>Enter the Security Token from your Authenticator app</p>
        <CustomPin
          length={6}
          onComplete={val => setTwoFactor(x => ({ ...x, pin: val }))}
          isInvalid={!!form.message}
          errorMessage="Incorrect Security Token"
        />
        <StyledButton
          color="primary"
          block
          className="w-full"
          isLoading={monitors.twoFactorLogin.executing}
          isDisabled={twoFactor.pin.length < 6}
          onPress={handleLogin}
        >
          Login
        </StyledButton>
      </div>
    );
  },
  {
    name: 'TwoFactorLogin',
    monitors: services => [services.login.twoFactorLogin],
  },
);
